import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

import ColorPickerDialog from 'views/Common/ColorPickerDialog';

const ColorField = ({ label, value, onChange, helperText }) => {
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.75 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          component="button"
          type="button"
          aria-label={value ? `${label}: ${value}` : `${label}: none`}
          onClick={() => setOpen(true)}
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            cursor: 'pointer',
            bgcolor: value || 'transparent',
            backgroundImage: value
              ? 'none'
              : 'linear-gradient(135deg, transparent 46%, rgba(0,0,0,0.25) 46%, rgba(0,0,0,0.25) 54%, transparent 54%)',
          }}
        />
        <Button size="small" onClick={() => setOpen(true)}>
          {value ? 'Change' : 'Pick a colour'}
        </Button>
        {value && (
          <Button size="small" color="inherit" onClick={() => onChange(null)}>
            Clear
          </Button>
        )}
      </Box>
      {helperText && (
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      )}
      <ColorPickerDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        onColorSelected={(hex) => {
          onChange(hex);
          setOpen(false);
        }}
      />
    </Box>
  );
};

ColorField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  helperText: PropTypes.string,
};

export default ColorField;
